/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

export default function FileUpload(props) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="72.000000pt"
      height="72.000000pt"
      viewBox="0 0 72.000000 72.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,72.000000) scale(0.100000,-0.100000)"
      >
        <path
          d="M250 525 l-105 -105 63 0 62 0 0 -90 0 -90 90 0 90 0 0 90 0 90 62 0 63 0 -105 105 c-58 58 -107 105 -110 105 -3 0 -52 -47 -110 -105z"
        />
        <path
          d="M150 150 l0 -30 210 0 210 0 0 30 0 30 -210 0 -210 0 0 -30z"
        />
      </g>
    </svg>
  );
}
